module.exports = __webpack_public_path__ + "img/twitter.2ca77176.svg";